import { WrapPresentation } from '../ui/presentation'
import '../styles/pages/presentation.css'

export const PresentationPage = () => {
  return (
    <div className='presentation-page'>
        <img src="../assets/cover.png" alt="Cover Travel Center Guatemala" className='presentation-background-img' fetchPriority="high" />
        {/* <h1>Travel Center Guatemala</h1> */}
        <WrapPresentation />
    </div>
  )
}
